import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useI18n } from 'vue-i18n'
  import { computed } from 'vue'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ViewDetailsButton',
  props: {
    booking: {
      type: Object,
      required: true,
    },
    buttonStyle: {
      type: String,
      default:
        'button-secondary secondary-normal small flex-grow-1 action-button',
    },
  },
  emits: ['view-details'],
  setup(__props, { emit: __emit }) {

  const props = __props

  const { t } = useI18n()
  const emit = __emit

  const handleViewDetails = () => {
    emit('view-details', props.booking)
  }

  const buttonClass = computed(() => props.buttonStyle)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(buttonClass.value),
    onClick: handleViewDetails
  }, _toDisplayString(_unref(t)('reservations.viewDetails')), 3))
}
}

})